module.exports = __webpack_public_path__ + "static/media/student-end-season-head.ac19903c.png";